import api from './api';
import { NFService, NFServiceFilter } from '../services/tipos';

export const NFServiceService = {
  listarPaginado: async (filter: NFServiceFilter) => {
    const response = await api.post('/nfservice/list', filter);
    return response.data;
  },

  emitir: async (
    idPagamento: string | undefined, 
    idServico: string, 
    idEmpresa: string, 
    idLocatario?: string, 
    valor?: number, 
    descricao?: string, 
    idNf?: string
  ) => {
    const response = await api.post('/nfservice/emitir', { 
      idPagamento, 
      idServico, 
      idEmpresa, 
      idLocatario, 
      valor, 
      descricao, 
      idNf
    });
    return response.data;
  },

  agendar: async (idPagamento: string | null, idLocatario: string | null, idServico: string, idEmpresa: string, dataEmissao: string, valor: number, descricao?: string) => {
    const response = await api.post('/NFService/Agendar', {
      idPagamento,
      idLocatario,
      idServico,
      idEmpresa,
      DataEmissao: dataEmissao,
      Valor: valor,
      descricao
    });
    return response.data;
  },

  editarAgendamento: async (id: string, idServico: string, dataEmissao: string, valor: number, descricao?: string) => {
    const response = await api.post('/nfservice/editar-agendamento', {
      id,
      idServico,
      DataEmissao: dataEmissao,
      Valor: valor,
      descricao
    });
    return response.data;
  },

  consultar: async (id: string) => {
    const response = await api.get(`/nfservice/consultar/${id}`);
    return response.data;
  },

  cancelar: async (id: string, motivo: string) => {
    const response = await api.post('/nfservice/cancelar', { id, motivo });
    return response.data;
  },

  baixarXml: async (id: string) => {
    const response = await api.get(`/nfservice/baixar-xml/${id}`, { responseType: 'blob' });
    return response.data;
  },
  
  obterPorPagamento: async (idPagamento: string) => {
      const response = await api.get(`/nfservice/pagamento/${idPagamento}`);
      return response.data;
  }
};
